// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2neaW","calendarButtons":"ClockData_calendarButtons__1O5B6"};